var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-black"},[_c('h1',{staticClass:"title text-light"},[_vm._v("Favorite products")]),_c('ItemList',{staticClass:"card-item",attrs:{"products":this.$store.state.user?.favorites,"image":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }